import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import StudentAvatar from "./student.avatar";
import { useNavigate } from "react-router-dom";

export default function StudentName(props) {
	const navigate = useNavigate();
	let { student } = props;
	if (!student?.name) {
		return;
	}

	const size = props?.size || 24;
	const href = "/students/" + student.id;
	const nowrapSx = { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: "ellipsis" };

	const content = (
		<Stack alignItems="center" sx={{ mb: 0 }}>
			<StudentAvatar student={student} size={size} />
			<Typography variant={props.variant} sx={nowrapSx}>{student.name}</Typography>
		</Stack>
	);

	if (window.location.pathname != href && !props?.hideLink) {
		return <Link onClick={()=>navigate(href)} sx={{ textDecoration: 'none' }}>{content}</Link>
	}
	else {
		return content;
	}
}